import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgModule } from '@angular/core';
import { ResizableComponent } from './components/resizable/resizable.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { PrettyDatePipe } from '../pipes/pretty-date.pipe';
import { PrettyDateTimePipe } from '../pipes/pretty-date-time.pipe';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PopoverModule } from 'primeng/popover';

import { TimelineModule } from 'primeng/timeline';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
// import { InputTextareaModule } from "primeng/inputtextarea";
import { TooltipModule } from 'primeng/tooltip';
import { ChipsModule } from 'primeng/chips';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ListboxModule } from 'primeng/listbox';
import { FileUploadModule } from 'primeng/fileupload';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { NotificationShowComponent } from '../modules/admin/notification-show/notification-show.component';
// import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { AccordionModule } from 'primeng/accordion';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { StandardPhoneInputComponent } from './components/standard-phone-input/standard-phone-input.component';
import { TimerComponent } from './components/timer/timer.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';

import { MultiTimerPanelComponent } from './components/multi-timer-panel/multi-timer-panel.component';
import { LogTimeModalComponent } from '../modules/admin/projects/log-time-modal/log-time-modal.component';
import { UserSelectorComponent } from './components/user-selector/user-selector.component';
import { FormatTimePipe } from './pipes/format-time.pipe';
import { TimeLogsListComponent } from './components/time-logs-list/time-logs-list.component';
import { EditTimerModalComponent } from './components/edit-timer-modal/edit-timer-modal.component';
import { MenuModule } from 'primeng/menu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmationService } from 'primeng/api';
import { TimeLogChartComponent } from './components/time-log-chart/time-log-chart.component';
import { LoaderComponent } from './components/loader/loader.component';
import { UserCompletedTasksComponent } from './components/user-completed-tasks/user-completed-tasks.component';
import { BetaBadgeComponent } from './components/beta-badge/beta-badge.component';
import { ExtBadgeComponent } from './components/ext-badge/ext-badge.component';
import { MilestoneDotComponent } from './components/milestone-dot/milestone-dot.component';
import { SlideToggleComponent } from './components/slide-toggle/slide-toggle.component';
import { TaskHoverActionsComponent } from './components/task-hover-actions/task-hover-actions.component';
import { TimesheetExportComponent } from './components/timesheet-export/timesheet-export.component';

import { SkeletonModule } from 'primeng/skeleton';

@NgModule({
  declarations: [
    LogTimeModalComponent,
    StandardPhoneInputComponent,
    ResizableComponent,
    PrettyDatePipe,
    PrettyDateTimePipe,
    NotificationShowComponent,
    TimerComponent,
    MultiTimerPanelComponent,
    UserSelectorComponent,
    FormatTimePipe,
    TimeLogsListComponent,
    EditTimerModalComponent,
    TimeLogChartComponent,
    LoaderComponent,
    TimesheetExportComponent,
  ],
  imports: [
    SkeletonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    GoogleMapsModule,
    TimelineModule,
    OverlayPanelModule,
    PopoverModule,

    ConfirmPopupModule,
    ConfirmDialogModule,
    CalendarModule,
    CheckboxModule,
    InputTextModule,
    TooltipModule,
    ChipsModule,
    SelectButtonModule,
    ListboxModule,
    FileUploadModule,
    TimelineModule,
    ScrollPanelModule,
    DialogModule,
    DropdownModule,
    // VirtualScrollerModule,
    AccordionModule,
    ProgressSpinnerModule,
    ButtonModule,
    DragDropModule,
    MultiSelectModule,
    InputNumberModule,
    MenuModule,
    AutoCompleteModule,
    UserCompletedTasksComponent,
    BetaBadgeComponent,
    ExtBadgeComponent,
    MilestoneDotComponent,
    SlideToggleComponent,
    TaskHoverActionsComponent,
  ],
  exports: [
    LogTimeModalComponent,
    StandardPhoneInputComponent,
    ResizableComponent,
    PrettyDatePipe,
    PrettyDateTimePipe,
    NotificationShowComponent,
    TimerComponent,
    MultiTimerPanelComponent,
    UserSelectorComponent,
    FormatTimePipe,
    TimeLogsListComponent,
    EditTimerModalComponent,
    TimeLogChartComponent,
    LoaderComponent,
    UserCompletedTasksComponent,
    PopoverModule,
    CalendarModule,
    FormsModule,
    MenuModule,
    AutoCompleteModule,
    SkeletonModule,
    TooltipModule,
    BetaBadgeComponent,
    ExtBadgeComponent,
    MilestoneDotComponent,
    SlideToggleComponent,
    TaskHoverActionsComponent,
    TimesheetExportComponent,
  ],
  providers: [ConfirmationService],
})
export class SharedModule {}
